import type { UtmParams } from "@/types/embed";

/** Read UTM params from a query string (defaults to the current location). */
export function parseUtmFromSearch(search: string = window.location.search): UtmParams {
  const params = new URLSearchParams(search);
  const get = (key: string) => params.get(key)?.trim() || undefined;
  return {
    utmSource: get("utm_source"),
    utmMedium: get("utm_medium"),
    utmCampaign: get("utm_campaign"),
    utmContent: get("utm_content"),
    utmTerm: get("utm_term"),
  };
}

/** Merge two UTM objects, preferring defined values from `override`. */
export function mergeUtm(base: UtmParams, override: UtmParams): UtmParams {
  return {
    utmSource: override.utmSource ?? base.utmSource,
    utmMedium: override.utmMedium ?? base.utmMedium,
    utmCampaign: override.utmCampaign ?? base.utmCampaign,
    utmContent: override.utmContent ?? base.utmContent,
    utmTerm: override.utmTerm ?? base.utmTerm,
  };
}
